import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { Angular2TokenService } from 'angular2-token'
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Observable } from 'rxjs';
import { Transaction } from "@models/transaction";
import { DirectDebitSummary } from "@models/direct-debit-summary";

export interface FetchDirectDebitSummaryParams {
  id: number,
  shallow?: boolean
}

export interface FetchTransactionParams {
  debtor_id?: number,
  has_owing?: boolean,
  transaction_types?: number[],
  payment_types?: number[],
}

export interface TransferTransactionParams {
  from_tx_id?: number,
  to_tx_id?: number,
  amount?: number,
}

export interface FetchDdsTransactionsParams {
  dds_id: number,
  view_type: string,
}

@Injectable()
export class TransactionService {

  private transactionsUrl: string = 'transactions'
  private directDebitSummariesUrl: string = 'direct_debit_summaries'

  constructor(
    private http: Angular2TokenService,
    private store: Store<AppState>,
  ) {}

  index(params: any): Observable<Transaction[]> {
    const searchParams: URLSearchParams = new URLSearchParams()
    const options: any = { search: searchParams }

    for (let key in params) { searchParams.set(key, params[key]) }

    return this.http.get(this.transactionsUrl, options)
      .map((res: Response) => res.json().map((r: any) => Transaction.clone(r)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  create(t: Transaction): Observable<boolean> {
    return this.http.post(this.transactionsUrl, t.serializeForRails())
      .mapTo(true)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  transfer(params: TransferTransactionParams): Observable<boolean> {
    return this.http.post(`${this.transactionsUrl}/transfer`, params)
      .mapTo(true)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  recharge(id: number): Observable<boolean> {
    return this.http.patch(`${this.transactionsUrl}/${id}/recharge`, {})
      .mapTo(true)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  batchRecharge(ids: number[]): Observable<boolean> {
    return this.http.patch(`${this.transactionsUrl}/batch_recharge`, { ids })
      .mapTo(true)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  recordOtherPayment(t: Transaction): Observable<boolean> {
    return this.http.patch(`${this.transactionsUrl}/${t.parentId}/record_other_payment`, t)
      .mapTo(true)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  directDebitSummaryFetch(params: FetchDirectDebitSummaryParams): Observable<DirectDebitSummary> {
    const searchParams: URLSearchParams = new URLSearchParams()
    const options: any = { search: searchParams }

    for (let key in params) { searchParams.set(key, params[key]) }

    return this.http.get(`${this.directDebitSummariesUrl}/${params.id}`, options)
      .map((res: Response) => DirectDebitSummary.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  directDebitSummariesIndex(): Observable<DirectDebitSummary[]> {
    return this.http.get(this.directDebitSummariesUrl)
      .map((res: Response) => res.json().map((d: any) => DirectDebitSummary.clone(d)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  fetchDdsTransactions(params: FetchDdsTransactionsParams): Observable<Transaction[]> {
    const searchParams: URLSearchParams = new URLSearchParams()
    const options: any = { search: searchParams }

    for (let key in params) { searchParams.set(key, params[key]) }

    return this.http.get(`${this.directDebitSummariesUrl}/${params.dds_id}/transactions`, options)
      .map((res: Response) => res.json().map((t: any) => Transaction.clone(t)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/transaction.ts